module.exports = __webpack_public_path__ + "static/media/28.6829e3aa.mp3";